<script setup lang="ts">
import { McdViewError } from '~/lib/models/errors'
import { GTMViewContentGroup, pageAnalyticsTagPlaceholder, GTMContentGroup } from '~/lib/models/gtm'

definePageMeta({
  middleware: ['home-redirect'],
})

const contentStore = useContentStore()
const route = useRoute()
const { trackPageView } = useGTM()
const errorView = useErrorView()

const { error, data: page } = await useWrapperKeyAsyncData(`page-${route.path}`, () => {
  return contentStore.loadPage(route.path)
})

if (error.value) {
  errorView.value = new McdViewError(error.value.message, 404)
}

onMounted(() => {
  // track GA page_view event
  if (page.value) {
    const pageAnalyticsTag = page.value.pageAnalyticsTag

    let content: GTMViewContentGroup = {}
    if (page.value.path === '/') {
      // Home
      content.cg = GTMContentGroup.primary.HOME
    } else if (pageAnalyticsTag) {
      // strapi page with tag
      let tag = pageAnalyticsTag
      const hasPlaceholderToReplace = pageAnalyticsTag.includes(pageAnalyticsTagPlaceholder)
      if (hasPlaceholderToReplace) {
        const pathSplitted = page.value.path.split('/')
        const lastSlugPath = pathSplitted?.[pathSplitted.length - 1] || ''
        tag = tag.replace(pageAnalyticsTagPlaceholder, lastSlugPath)
      }
      const [cg, cg2, cg3] = tag.split('/')
      content = { cg, cg2, cg3 }
    } else {
      // strapi page without tag
      content.cg = GTMContentGroup.primary.HOME
      content.pageTitle = `${GTMContentGroup.primary.HOME}${page.value.path}`
    }

    trackPageView(content)
  }
})
</script>

<template>
  <LazyErrorView v-if="errorView || error" :error="errorView || error" />
  <Page v-else-if="page" />
  <Loader v-else full />
</template>
